export async function hash(obj: object | undefined): Promise<string> {
  if (!obj) return ''
  const str = JSON.stringify(obj, Object.keys(obj).sort()); // Ensure consistency in keys
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
  return Array.from(new Uint8Array(buf))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('');
}
